import { html, nothing, PropertyValueMap, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import {
  getInstructorSampleOrderOrderId,
  getInstructorSampleOrderStatus,
  getSampleDataError,
  getSchoolAddressError,
  getSchoolAddresses,
  isFailedSampleData,
  isFailedSchoolAddress,
} from './instructor-sample.selectors';
import { getMagentoSchoolAddressThunk } from './instructor-sample.thunks';
import { getCart, getCartError, getCartStatus, getHeInstructorInvalidProductsRemoved, isCartEmpty } from '../cart/shop-cart/store/shop-cart.selectors';
import { isLoggedOutUser, selectUser } from '../user-profile/user-profile.selectors';
import { SchoolAddress } from './instructor-sample.interface';
import { Product, ShopCart } from '../cart/shop-cart/interfaces/shop-cart.interface';
import { StoreState } from '../../store/store.interface';
import { default as env, default as environment } from '../../common/environment';
import { isDesktop, reverseCatalogMap } from '../../common/utils/util';
import store, { waitForCart, waitForInstructorSampleSchoolAddress } from '../../store/store';
import '../alert/alert';
import { FormBaseComponent } from '../base-component/forms/form-base-component';
import { booleanConverter } from '../../common/converters';
import emit from '../../common/events';
import { ActionStatus } from '../../common/constants/action-status';
import {
  getPdpLink,
  isHeCustomStoreProduct,
  isHePrivateStoreProduct,
} from '../../common/utils/product-util';
import { MessageType } from '../alert/global-message.interface';
import { MagentoBookstoreAddress, PaymentInformation, PaymentTypeMagento } from '../checkout/shop-checkout.interface';
import { getSuccessUrl } from '../../common/utils/cart-util';
import { ApiError, handleApiError } from '../../common/utils/api-utils';
import { PARAM_ORDER_ID } from '../../common/constants/shop-api';
import { removeCookie } from '../../common/cookies';
import { GENERIC_TRANSACTION_ERROR, MISSING_FORM_FIELDS_ERROR } from '../../common/constants/api-constants';
import { getShopCart } from '../cart/shop-cart/thunks/get-shop-cart.thunk';
import { ariaLabelWithNewTab } from '../../common/utils/a11y-util';
import { getCustomerId } from '../customer/customer';
import { instructorSampleOrderThunk } from './instructor-sample-magento.thunks';
import {
  getInstructorSampleSchoolAddressesForSchool,
  getInstructorSampleSchoolAddressDescription,
  getInstructorSampleSchoolAddressLabel,
  getValidInstructorSampleInstitutions,
} from './utils/instructor-sample-address.util';
import { getCartSamplingErrorMessage } from './utils/instructor-sample-error.util';
import { ErrorCode } from '../../common/utils/error-code-utils';
import { InstructorSampleAnalytics } from './instructor-sample.analytics';
import { redirectToProductOrHome } from './utils/instructor-sample.util';
import { setHeInstructorInvalidProductsRemoved } from '../cart/shop-cart/store/shop-cart.store';
import { mhecommLocalStorage } from '../../common/local-storage';
import { INSTRUCTOR_PRODUCTS_REMOVED_KEY } from '../../common/constants/anayltics.constants';

/**
 * Instructor  Component. Capture instructor information from user.
 */
@customElement('mhecomm-instructor-sample-form')
export class InstructorSampleForm extends connect(store)(FormBaseComponent) {
  @property()
  store?: string;

  @property({ reflect: true })
  institution = '';

  @property({ reflect: true })
  courseName = '';

  @property({ reflect: true })
  courseNumber = '';

  termList: Array<string> = [
    'Select',
    'NA',
    'WINTER',
    'SPRING',
    'SUMMER',
    'FALL',
    '4-WEEK',
    '6-WEEK',
    '8-WEEK',
    '10-WEEK',
    '12-WEEK',
    'ANNUAL',
  ];

  @property({ reflect: true })
  studentCount = '';

  @property({ reflect: true })
  term = '';

  @property({ reflect: true })
  year = '';

  @property({ reflect: true })
  titlePresentText = '';

  @property({ reflect: true })
  authorPresentText = '';

  @property({ reflect: true })
  sfdcAddressId = '';

  @property({ converter: booleanConverter })
  disabled = true;

  schoolId = '';

  decisonDate: Date | undefined;

  selectedDecisionDate = '';

  @state()
  showReview = false;

  private collapse: any;

  private isAddInfoRequired = false;

  product?: Product | undefined;

  schoolAddressList: SchoolAddress[] = [];

  selectedSchoolList: SchoolAddress[] = [];

  institutionNameList: SchoolAddress[] = [];

  addressReview: SchoolAddress | undefined;

  @state()
  buttonLabel: string = 'Review Sample';

  @state()
  protected isPlacingOrder = false;

  @state()
  protected isComplete = false;

  /**
   * Error message to be displayed.
   */
  @state()
  errorMessage = '';

  private lbl_courseName = `Course Name`;
  private lbl_courseNumber = `Course Number`;
  private lbl_term = `Term`;
  private lbl_year = `Year`;
  private lbl_StudentCount = `Expected Number of Students`;

  private isCourseNameValid = true;
  private isCourseNumberValid = true;
  private isTermValid = true;
  private isYearValid = true;
  private isStudentCountValid = true;
  private isAddressValid = true;
  private formAnalyticsLogged = true;

  private courseNameId = `courseName`;
  private courseNumberId = `courseNumber`;
  private termId = `term`;
  private yearId = `year`;
  private stundentsCountId = `stundentsCount`;
  private shippingMethodOptionsId = `shippingMethodOptions`;
  private isCartEmpty = false;
  private isInstructorCartProductsRemoved = false;

  private isVirtualProduct(): boolean {
    return this.product?.productMetadata?.virtual === true;
  }

  private isPhysicalProduct(): boolean {
    return this.product?.productMetadata?.virtual === false;
  }

  private shouldShowSchoolAddress(): boolean {
    return this.product?.productMetadata?.virtual !== undefined && this.selectedSchoolList?.length > 0;
  }

  private getSchoolAddressLabel(): string {
    return getInstructorSampleSchoolAddressLabel(this.isVirtualProduct());
  }

  private getSchoolAddressDescription(): string {
    return getInstructorSampleSchoolAddressDescription(this.isVirtualProduct());
  }

  async validateInfo() {
    this.isCourseNameValid = this.courseName === '' || this.courseName === undefined ? false : true;
    this.isCourseNumberValid = this.courseNumber === '' || this.courseNumber === undefined ? false : true;
    this.isTermValid = this.term === '' || this.isTermValid === undefined || this.term === 'Select' ? false : true;
    this.isYearValid = this.year === '' || this.isYearValid === undefined || this.year === 'Select' ? false : true;
    this.isStudentCountValid = this.studentCount === '' || this.studentCount === undefined ? false : true;
    this.isAddressValid = this.sfdcAddressId === '' || this.sfdcAddressId === undefined ? false : true;

    if (
      !this.isYearValid ||
      !this.isCourseNameValid ||
      !this.isCourseNumberValid ||
      !this.isTermValid ||
      !this.isStudentCountValid ||
      !this.isAddressValid
    ) {
      throw new Error(MISSING_FORM_FIELDS_ERROR);
    }
  }
  connectedCallback(): void {
    super.connectedCallback();
    this.addEventListener(`${this.id}-instructor-sample-form`, this.submit);
  }

  stateChanged(state: StoreState) {
    const userIsLoggedOut = isLoggedOutUser(state);
    if (!window.Mhecomm_Editor) {
      if (userIsLoggedOut) {
        emit({
          element: this,
          name: 'checkout-sampling-redirect',
          dataLayer: true,
          detail: {
            reason: 'logged-out-user',
          },
        });
        sessionStorage.clear();
        window.location.href = env().loginUrl;
      }
    }

    this.isPlacingOrder = state.instructorSampleState.getInstructorSampleOrder.status === ActionStatus.loading;
    this.handleApiFailures(state);
  }

  getProductCardData(cart?: ShopCart) {
    this.product = cart !== undefined ? cart?.products[0] : undefined;
  }

  private getCustomStorePdpLink(product: Product): string {
    const isbn = product?.productIdentifier.isbn13
      ? product.productIdentifier.isbn13
      : product.productIdentifier.isbn10
      ? product.productIdentifier.isbn10
      : product.productIdentifier.mhid;
    let link = '';
    if (this.store) {
      link = new URL(
        `/prek-12/custom/store/${this.store}/product/${product.productIdentifier.mhid}.html`,
        environment().mheducationUrl
      ).href;
    } else if (isbn && (isHeCustomStoreProduct(product) || isHePrivateStoreProduct(product))) {
      link = getPdpLink({
        businessUnit: reverseCatalogMap(product.productIdentifier.businessUnit),
        isbn: isbn,
        productType: product.productIdentifier.productType?.toUpperCase(),
      });
    } else if (isbn) {
      link = getPdpLink({
        businessUnit: reverseCatalogMap(product.productIdentifier.businessUnit),
        isbn,
      });
    }
    return link;
  }

  renderComp(): TemplateResult {
    return this.isCartEmpty
      ? this.isInstructorCartProductsRemoved
        ? html`${getCartSamplingErrorMessage(ErrorCode.HE_INSTRUCTOR_GUEST_PRODUCTS_REMOVED, this)}`
        : html`${getCartSamplingErrorMessage(ErrorCode.HE_INSTRUCTOR_CART_EMPTY, this)}`
      : this.renderForm();
  }

  renderBackButton() {
    return html` <div class="mb-2">
      <button type="button" class="btn btn-link p-0" aria-expanded="false" id="backtoproduct" @click=${this.backToProductAction}>
        Remove from cart and go back to product
      </button>
    </div>`;
  }

  renderForm() {
    return html`
      ${this.renderBackButton()}
      ${this.schoolAddressList && this.schoolAddressList.length > 0
        ? html`${this.renderSampleForm()}`
        : html`${this.renderAccountValidationErorr()}`}
    `;
  }

  renderSampleForm() {
    return html` ${this.errorMessage
        ? html`
            <div id="orderError">
              <mhecomm-alert
                type=${MessageType.danger}
                message=${this.errorMessage}>
              </mhecomm-alert>
            </div>
          `
        : nothing}

      <mhecomm-alert
        type=${MessageType.info}
        message="Only one title can be requested at a time"
        ?dismissible="${true}"
      ></mhecomm-alert>

      <form id="${this.id}" class="row g-3">
        ${!this.showReview
          ? html` ${this.renderEditInstitutionInfo()} ${this.renderSchoolAddress()}`
          : html`${this.renderInstitutionReview()} ${this.renderAddressReview()}`}
        ${this.isPhysicalProduct() && !this.showReview
          ? html` <p>
              Sample texts can only be shipped to institutional addresses. If you would like to ship to another address,
              <a
                href="${environment().shopUrl}/store/paris/user/findltr.html"
                target="_blank"
                aria-label="${ariaLabelWithNewTab('Sample texts can only be shipped to institutional addresses.  If you would like to ship to another address,please contact your sales rep')}"
                id="contactSaleRep"
                @click="${this.emitContactSalesRep}"
              >
                please contact your sales rep.
              </a>
            </p>`
          : nothing}
        ${this.renderButton()}
      </form>`;
  }

  emitContactSalesRep() {
    this.emitElement('contact-sales-rep-accordion');
  }

  renderEditInstitutionInfo() {
    if (this.formAnalyticsLogged) {
      this.emit('mhecomm-instructor-sampling-form');
      this.formAnalyticsLogged = false;
    }
    return html`
    <div class="d-flex bg-light pt-3 pb-2 px-3"><h2 class="h5 flex-grow-1">Institution Information</h2></div>
    <span class="mt-1 mb-2"> <small>All fields are required unless otherwise noted.</small> </span>
      <div class="col-md-12 mt-0">
            <label id="institution_label" for="institution_lbl" class="form-label">Institution</label>
            <input type="text" class="form-control ${
              this.institutionNameList.length === 1 ? 'd-block' : 'd-none'
            }" id="institution_lbl" .value="${this.institution}" ?disabled="${this.disabled}">
            <select id="institution_select" class="form-select ${
              this.institutionNameList.length > 1 ? 'd-block form-select' : 'd-none'
            }" .value="${this.schoolId}" @change="${this.updateInstitution}" aria-label="Institution">
              ${this.institutionNameList.map(
                (institution) =>
                  html`<option value="${institution.schoolId}" ?selected="${this.schoolId === institution.schoolId}">
                    ${institution.schoolName}
                  </option>`
              )}
            </select>
      </div>

      
          <div class="col-md-12">
            <label for="${this.courseNameId}" class="form-label">${this.lbl_courseName}</label>
            <input type="text" class="form-control ${!this.isCourseNameValid ? 'is-invalid' : ''}" id="${
      this.courseNameId
    }" .value="${this.courseName ? this.courseName : ''}"
            @input="${(_e: InputEvent) =>
              (this.courseName = (_e.target as HTMLInputElement).value)}" aria-describedby="${
      this.lbl_courseName
    }-field-error"
            required>
          </div>
          <div class="col-md-12">
            <label for="${this.courseNumberId}" class="form-label">${this.lbl_courseNumber}</label>
            <input type="text" class="form-control ${!this.isCourseNumberValid ? 'is-invalid' : ''}" id="${
      this.courseNumberId
    }" .value="${this.courseNumber}"
            @input="${(_e: InputEvent) =>
              (this.courseNumber = (_e.target as HTMLInputElement).value)}" aria-describedby="${
      this.lbl_courseNumber
    }-field-error"
            required>
          </div>

          <div class="col-6">
            <label for="${this.termId}" class="form-label">${this.lbl_term}</label>
            <select id="${this.termId}" class="form-select ${!this.isTermValid ? 'is-invalid' : ''}"  @change=${
      this.updateTerm
    } aria-describedby="${this.lbl_term}-field-error"
            required>
              ${this.termList.map(
                (value) =>
                  html`<option value=${value === 'Select' ? '' : value} ?selected=${this.term === value}>
                    ${value}
                  </option>`
              )}
          </select> 
          </div>

          <div class="col-6">
            <label for="${this.yearId}" class="form-label">${this.lbl_year}</label>
            
            <select id="${this.yearId}" class="form-select ${!this.isYearValid ? 'is-invalid' : ''}" @change="${
      this.updateYear
    }" aria-describedby="${this.lbl_year}-field-error" required>
              ${this.getYearList().map(
                (value) =>
                  html`<option value=${value === 'Select' ? '' : value} ?selected=${this.year === value}>
                    ${value}
                  </option>`
              )}
           </select>
          </div>
          <div class="col-12">
            <label for="${this.stundentsCountId}" class="form-label">${this.lbl_StudentCount}</label>
            <input type="number" class="form-control ${!this.isStudentCountValid ? 'is-invalid' : ''}" id="${
      this.stundentsCountId
    }" .value="${this.studentCount}"
            onkeydown="return event.keyCode !== 69"
            pattern="[0-9]"
            min="0"
            @change="${(_e: InputEvent) => (this.studentCount = (_e.target as HTMLInputElement).value)}"
            @input="${(_e: InputEvent) => (this.studentCount = (_e.target as HTMLInputElement).value)}"
            aria-describedby="${this.lbl_StudentCount}-field-error" required>
          </div>
          <div class="col-12">
          <button
              type="button"
              class="btn btn-link p-0 ${this.isAddInfoRequired ? 'd-none' : ''}"
              data-bs-target="#addInfoSelection"
              data-bs-toggle="collapse"
              aria-controls="addInfoSelection"
              aria-expanded="false"
              id="addInfoLink"
              @click=${this._handleCollapseToggle}>
              Optional Information
              ${this.uxtIconReady ? html` <uxt-icon id="enterDropDownIcon" icon="chevron-down"></uxt-icon> ` : ''}
          </button>
          <br>
          (This information helps us to quickly approve your request.)
        </div>    
          <div class="row g-3 mt-0 collapse ${this.isAddInfoRequired ? 'd-none' : ''}" id="addInfoSelection">    
              <div class="col-md-12">
                <label for="title" class="form-label">Title of Present Text (optional)</label>
                <input type="text" class="form-control" id="title" .value="${this.titlePresentText}"
                @input="${(_e: InputEvent) => (this.titlePresentText = (_e.target as HTMLInputElement).value)}" 
                aria-label="Title of Present Text" >
              </div>
              <div class="col-md-12">
                <label for="author" class="form-label">Author of Present Text (optional)</label>
                <input type="text" class="form-control" id="author" .value="${this.authorPresentText}"
                @input="${(_e: InputEvent) => (this.authorPresentText = (_e.target as HTMLInputElement).value)}" 
                aria-label="Author of Present Text" >
              </div>
              <div class="col-md-12">
                <label for="decisionDate" class="form-label">Decision Date (optional)</label>
                <input type="date" class="form-control" id="decisionDate" onfocus="this.showPicker()" .valueAsDate="${
                  this.decisonDate ? this.decisonDate : null
                }"
                @change="${this.updateDate}" @input="${this.updateDate}">
                <i class="fa fa-calendar"></i>
                </input>
              </div>
          </div>
         
    `;
  }
  renderSchoolAddress() {
    return html`${this.shouldShowSchoolAddress()
      ? html`
          <fieldset>
            <legend class="d-flex bg-light pt-3 pb-2 px-3">
              <h2 class="h5 flex-grow-1">${this.getSchoolAddressLabel()}</h2>
            </legend>
            <span class="fw-bold"> ${this.getSchoolAddressDescription()} </span>
            <div id="shipping-method-options" class="mt-2">
              ${this.selectedSchoolList.map((schoolAddress: SchoolAddress) => {
                return html`<div class="form-check mb-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="shipping-method-option"
                    id="shp-mth-${schoolAddress.sfdcAddressId}"
                    ?checked="${schoolAddress.sfdcAddressId == this.sfdcAddressId}"
                    value="${schoolAddress.sfdcAddressId}"
                    @change="${(_e: InputEvent) => (this.sfdcAddressId = (_e.target as HTMLInputElement).value)}"
                  />
                  <label class="fw-normal pe-2" for="shp-mth-${schoolAddress.sfdcAddressId}">
                    ${this.formatAddress(schoolAddress)}
                  </label>
                </div>`;
              })}
            </div>
          </fieldset>
        `
      : ''} `;
  }

  renderAddressReview() {
    this.addressReview = this.selectedSchoolList
      ? this.selectedSchoolList.find((x) => x.sfdcAddressId == this.sfdcAddressId)
      : undefined;
    const addressLineTwo = this.addressReview && this.addressReview.lineTwo ? this.addressReview.lineTwo + ', ' : '';

    const address = this.addressReview
      ? this.addressReview.city +
        ', ' +
        this.addressReview.state +
        ', ' +
        this.addressReview.zipCode +
        ', ' +
        this.addressReview.country
      : '';

    return html`${this.shouldShowSchoolAddress()
      ? html`
          <div class="d-flex bg-light pt-3 pb-2 px-3">
            <h2 class="h5 flex-grow-1">${this.getSchoolAddressLabel()}</h2>

        <div>
          <button
                id="edit-${this.id}"
                @click="${this.onClickEditAddress}"
                class="btn btn-link p-0"
                aria-label="Edit ${this.getSchoolAddressLabel()}"
              >
                Edit
              </button>
            </div>
          </div>
          <address>
            ${this.addressReview?.lineOne} <br />
            ${addressLineTwo} ${address}
          </address>
        `
      : ''} `;
  }
  renderButton() {
    return html`
      <button
        type="button"
        class="btn btn-primary btn-lg mt-4 mb-2 w-100"
        @click=${this.submit}
        ?disabled="${this.isPlacingOrder || this.isComplete || !this.shouldShowSchoolAddress()}"
        id="reviewSampleBtn"
      >
        ${!this.showReview ? html`Review Sample` : html`Request a Sample`}
      </button>
    `;
  }

  renderInstitutionReview() {
    return html`
      <div class="d-flex bg-light pt-3 pb-2 px-3">
        <h2 class="h5 flex-grow-1">Institution Information</h2>
        <div>
          <button
            id="info-edit-${this.id}"
            @click="${this.onClickEditInstitutionform}"
            class="btn btn-link p-0"
            aria-label="Edit Institution Information"
          >
            Edit
          </button>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <label> Institution: <span id="institution" class="fw-bold"> ${this.institution} </span> </label>
        </div>
        <div class="col-12">
          <label> Course Name: <span id="${this.courseNameId}" class="fw-bold"> ${this.courseName} </span> </label>
        </div>

        <div class="col-12">
          <label>
            Course Number: <span id="${this.courseNumberId}" class="fw-bold"> ${this.courseNumber} </span>
          </label>
        </div>

        <div class="col-12">
          <label> Term: <span id="${this.termId}" class="fw-bold"> ${this.term} </span> </label>
        </div>

        <div class="col-12">
          <label> Year: <span id="year" class="fw-bold"> ${this.year} </span> </label>
        </div>

        <div class="col-12">
          <label>
            Expected number of students: <span id="noOfStudents" class="fw-bold"> ${this.studentCount} </span>
          </label>
        </div>

        <div class="col-12">
          <label>
            Title of present text: <span id="titlePresentText" class="fw-bold"> ${this.titlePresentText} </span>
          </label>
        </div>

        <div class="col-12">
          <label>
            Author of present text: <span id="authorPresentText" class="fw-bold"> ${this.authorPresentText} </span>
          </label>
        </div>

        <div class="col-12">
          <label> Decision date: <span id="decisonDate" class="fw-bold"> ${this.formatDate()} </span> </label>
        </div>
      </div>
    `;
  }

  renderAccountValidationErorr() {
    return html`
      <style>
        #accountValidateError {
          margin-bottom: 500px;
        }
      </style>
      <div id="accountValidateError" class="alert alert-info d-flex align-items-top footer-space" role="alert">
        <uxt-icon icon="info-circle"></uxt-icon>
        <div>
          <p class="mb-0">
            &nbsp;&nbsp;Your account requires validation. Please
            <button class="alert-link btn btn-link p-0" @click="${this.onClickContactSalesRep}">
              contact your sales representative.
            </button>
          </p>
        </div>
      </div>
    `;
  }

  updateTerm(e) {
    const selected = (e.target as HTMLInputElement).value;
    this.term = selected != 'Select' ? selected : '';
  }

  updateYear(e) {
    const selected = (e.target as HTMLInputElement).value;
    this.year = selected != 'Select' ? selected : '';
  }

  updateDate(e) {
    this.decisonDate = new Date(e.target.value);
  }

  updateInstitution(e) {
    const institutionSelect = e.target as HTMLSelectElement;

    this.schoolId = institutionSelect.value;
    this.institution = institutionSelect.selectedOptions[0]?.textContent?.trim() ?? '';
    this.updateSelectedSchoolList(this.schoolId);
  }

  /**
   * Retrieves the filtered school address list and throws an error if empty.
   *
   * @param schoolId
   */
  private updateSelectedSchoolList(schoolId: string): void {
    this.selectedSchoolList = this.getSchoolAddressesForSchool(schoolId);
    if (!this.selectedSchoolList.some((schoolAddress) => schoolAddress.sfdcAddressId === this.sfdcAddressId)) {
      this.sfdcAddressId = '';
    }

    if (this.selectedSchoolList.length === 0) {
      this.errorMessage = 'No address available.';
      InstructorSampleAnalytics.emit('mhecomm-instructor-sampling-no-address-available', this);
    } else {
      this.errorMessage = '';
    }
  }

  /**
   * Retrieves the school addresses for the current school, excluding the ones without an SFDC address ID.
   *
   * @param schoolId
   */
  private getSchoolAddressesForSchool(schoolId: string): SchoolAddress[] {
    return getInstructorSampleSchoolAddressesForSchool(this.schoolAddressList, schoolId);
  }

  private onClickEditInstitutionform(e: Event) {
    this.editStep(e);
    this.emitElement('mhecomm-checkout-step-edit-institution');
  }

  private onClickEditAddress(e: Event) {
    this.editStep(e);
    this.emitElement('mhecomm-checkout-step-edit-delivery-address');
  }

  private editStep(e: Event) {
    this.showReview = false;
    this.errorMessage = '';
    this.buttonLabel = !this.showReview ? 'Review Sample' : 'Request Sample';
    this.formAnalyticsLogged = true;
    if (this.authorPresentText || this.titlePresentText || this.decisonDate) {
      this.isAddInfoRequired = false;
    }
    e.preventDefault();
  }

  private onClickContactSalesRep(e: Event) {
    e.preventDefault();
    this.emitElement('contact-a-sales-rep');
    location.href = environment().shopUrl + '/store/paris/instructor/ltr.html';
  }

  protected async firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>) {
    super.firstUpdated(_changedProperties);
    store.dispatch(getMagentoSchoolAddressThunk());

    await store.dispatch(getShopCart({ store: this.store }));
    await waitForCart();
    await waitForInstructorSampleSchoolAddress();
    const state = store.getState() as StoreState;
    const isShopCartEmpty = isCartEmpty(state);
    const cart = getCart(state);
    const productsRemovedFlag = mhecommLocalStorage.get(INSTRUCTOR_PRODUCTS_REMOVED_KEY);

    if (isShopCartEmpty) {
      this.isCartEmpty = true;

      if (getHeInstructorInvalidProductsRemoved(state) || productsRemovedFlag === 'true') {
        this.isInstructorCartProductsRemoved = true;

        this.cleanInstructorProductRemovedFlagFromStateAndLS(state);
      }
      InstructorSampleAnalytics.emit('mhecomm-instructor-sampling-cart-empty', this);
    } else {
      // edge case: reset the heInstructorInvalidProductsRemoved and removing the local storage flag, even if the cart has some previously added product in the cart
      this.cleanInstructorProductRemovedFlagFromStateAndLS(state);
      this.getProductCardData(cart);
    }

    this.schoolAddressList = getSchoolAddresses(store.getState() as StoreState);
    if (this.schoolAddressList && this.schoolAddressList.length > 0) {
      this.institutionNameList = getValidInstructorSampleInstitutions(this.schoolAddressList);

      if (this.institutionNameList.length > 0) {
        this.institution = this.institutionNameList[0].schoolName ?? '';
        this.schoolId = this.institutionNameList[0].schoolId;
        this.updateSelectedSchoolList(this.schoolId);
      } else {
        this.updateSelectedSchoolList('');
      }
    } else {
      this.emit('mhecomm-instructor-sampling-instructor-not-validated');
    }
  }

  private cleanInstructorProductRemovedFlagFromStateAndLS(state: StoreState) {
    if (mhecommLocalStorage.get(INSTRUCTOR_PRODUCTS_REMOVED_KEY)) {
      mhecommLocalStorage.remove(INSTRUCTOR_PRODUCTS_REMOVED_KEY);
    }
    if (getHeInstructorInvalidProductsRemoved(state)) {
      store.dispatch(setHeInstructorInvalidProductsRemoved(false));
    }
  }

  protected updated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.updated(_changedProperties);
    this.collapse = this.bsInit('#addInfoSelection', window.bootstrap?.Collapse, { toggle: false })?.instance;
  }

  _handleCollapseToggle(event, isEdit?: boolean) {
    if (isEdit || (event && (event.type == 'click' || (event.type == 'keyup' && event.code == 'Space')))) {
      this.collapse.toggle();
      const addInfoLink = this.shadowRoot!.querySelector('#addInfoLink') as HTMLLinkElement;
      const dropDownIcon = this.shadowRoot!.querySelector('#enterDropDownIcon');
      if (addInfoLink.getAttribute('aria-expanded') == 'true') {
        addInfoLink.setAttribute('aria-expanded', 'false');
        dropDownIcon?.setAttribute('icon', 'chevron-down');
        this.emitElement('optional-information-accordion-close');
      } else {
        addInfoLink.setAttribute('aria-expanded', 'true');
        dropDownIcon?.setAttribute('icon', 'chevron-up');
        this.emitElement('optional-information-accordion-open');
      }
    }
  }

  emitElement(name: string) {
    emit({
      element: this,
      name: name,
      detail: { id: this.id },
      dataLayer: true,
    });
  }

  emitErrorMessage(name: string, error: string) {
    emit({
      element: this,
      name: name,
      detail: { id: this.id, error: error },
      dataLayer: true,
    });
  }
  emit(name: string) {
    emit({
      name: name,
      detail: { id: this.id },
      dataLayer: true,
    });
  }

  submit(_e: Event) {
    if (!this.showReview) {
      this.reviewOrder();
    } else {
      this.placeOrder();
    }
  }

  async backToProductAction(): Promise<void> {
    const product = this.product;
    let productUrl: string | undefined = undefined;

    if (product?.productIdentifier?.isbn10) {
      productUrl = this.getCustomStorePdpLink(product);
    }

    await redirectToProductOrHome(store.getState() as StoreState, this, productUrl);
  }

  scroll() {
    if (!isDesktop()) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }

  reviewOrder() {
    this.errorMessage = '';
    if (this.formElement?.checkValidity() === false) this.validateFields();
    this.validateInfo()
      .then(() => {
        this.showReview = true;
        this.emitInfo();
        this.scroll();
      })
      .catch((error: Error) => {
        if (error instanceof ApiError) {
          console.error(`Failed to validate`, error);
        } else {
          this.errorMessage = error.message;
        }
        this.emitErrorMessage('mhecomm-instructor-sampling-error', error.message);
      });
  }

  placeOrder() {
    const state = store.getState() as StoreState;
    const userInfo = selectUser(state);
    const schoolAddress = this.selectedSchoolList
        ? this.selectedSchoolList.find((x) => x.sfdcAddressId == this.sfdcAddressId)
        : undefined;

    if (!userInfo || !schoolAddress) {
      this.processOrderConfirmationFailure();
      return;
    }

    const bookstoreAddress = {
      region_code: schoolAddress?.state,
      country_id: schoolAddress?.country,
      street: [ schoolAddress?.lineOne ],
      postcode: schoolAddress?.zipCode,
      city: schoolAddress?.city,
      firstname: userInfo.givenName,
      lastname: userInfo.familyName,
      customer_id: getCustomerId(state),
      email: userInfo.email,
      telephone: userInfo.phone,
      same_as_billing: 1,
    } as MagentoBookstoreAddress;

    const paymentInformation = {
      paymentMethod: {
        method: PaymentTypeMagento.FREE,
        additional_data: {
          sfdc_address_id: schoolAddress.sfdcAddressId,
          institution: Number(schoolAddress.schoolId),
          courseName: this.courseName,
          courseNumber: this.courseNumber,
          term: this.term,
          year: Number(this.year),
          students: Number(this.studentCount),
          authorText: this.authorPresentText,
          titleText: this.titlePresentText,
          decisionDate: this.decisonDate?.toLocaleDateString(),
        },
      },
    } as PaymentInformation;

    store
    .dispatch(
      instructorSampleOrderThunk({
        bookstoreAddress,
        paymentInformation,
      })
    )
    .unwrap()
    .then(() => this._handleOrderCreationResult())
    .catch(() => this.processOrderConfirmationFailure());
  }

  _handleOrderCreationResult() {
    const state = store.getState() as StoreState;
    const orderId = getInstructorSampleOrderOrderId(state);

    if (!orderId) {
      return this.processOrderConfirmationFailure();
    }
    switch (getInstructorSampleOrderStatus(state)) {
      case ActionStatus.succeeded:
        return this.processOrderConfirmationSuccess(orderId);
      default:
        return this.processOrderConfirmationFailure();
    }
  }

  processOrderConfirmationSuccess(orderId) {
    const url = new URL(getSuccessUrl(this.store));
    url.searchParams.set(PARAM_ORDER_ID, orderId);
    sessionStorage.clear();
    removeCookie('MHCART');
    window.location.href = url.toString();
  }

  processOrderConfirmationFailure() {
    this.isComplete = false;
    this.errorMessage = GENERIC_TRANSACTION_ERROR;
    this.emitErrorMessage('mhecomm-instructor-sampling-error', this.errorMessage);
    throw new Error(GENERIC_TRANSACTION_ERROR);
  }

  getYearList() {
    const years: Array<string> = [];
    const currentYear = new Date().getFullYear();
    years.push('Select');
    for (let year = currentYear; year <= currentYear + 5; year++) {
      years.push(year.toString());
    }
    return years;
  }

  emitInfo() {
    emit({
      element: this,
      name: 'mhecomm-instructor-sampling-review',
      detail: {
        institutionInformation: this.institution,
        courseName: this.courseName,
        courseNumber: this.courseNumber,
        term: this.term,
        year: this.year,
        expectedNumberOfStudents: this.studentCount,
        titleOfPresentText: this.titlePresentText,
        authorPresentText: this.authorPresentText,
        decisionDate: this.decisonDate,
      },
      dataLayer: true,
    });
  }

  formatAddress(address: SchoolAddress): string {
    if (address) {
      const addressLineTwo =
        address.lineTwo || address.lineTwo != null || address.lineTwo != undefined ? address.lineTwo + ', ' : '';
      return (
        address.lineOne +
        ', ' +
        addressLineTwo +
        address.city +
        ', ' +
        address.state +
        ', ' +
        address.zipCode +
        ', ' +
        address.country
      );
    }
    return '';
  }

  formatDate(): string {
    return this.decisonDate
      ? this.decisonDate.getMonth() + '/' + this.decisonDate.getDate() + '/' + this.decisonDate.getFullYear()
      : '';
  }

  handleApiFailures(state: StoreState) {
    if (isFailedSampleData(state)) {
      this.errorMessage = 'Instructor Sample data API Failed';
      handleApiError(getSampleDataError(state));
      this.emitErrorMessage('mhecomm-instructor-sampling-error', this.errorMessage);
      return;
    } else if (isFailedSchoolAddress(state)) {
      this.errorMessage = 'School Address API Failed';
      handleApiError(getSchoolAddressError(state));
      this.emitErrorMessage('mhecomm-instructor-sampling-error', this.errorMessage);
      return;
    } else if (getCartStatus(state) === ActionStatus.failed) {
      this.errorMessage = 'Cart API Failed';
      handleApiError(getCartError(state));
      this.emitErrorMessage('mhecomm-instructor-sampling-error', this.errorMessage);
      return;
    }
  }

  protected validationMessage() {
    return {
      [this.courseNameId]: 'Please enter a Course Name to proceed',
      [this.courseNumberId]: 'Please enter a Course Number to proceed',
      [this.termId]: 'Please select a Term to proceed',
      [this.yearId]: 'Please select a Year to proceed',
      [this.stundentsCountId]: 'Please enter an Expected Number of Students to proceed',
      [this.shippingMethodOptionsId]: `Please select a ${this.getSchoolAddressLabel()} to proceed`,
    };
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-instructor-sample-form': InstructorSampleForm;
  }
}
